module.exports = __webpack_public_path__ + "img/Eros Atalia.7cba4c5c.jpg";